module.exports = __webpack_public_path__ + "img/ring_y_skip_0_null.8fec8c7e.png";